import type { ReactNode } from 'react';
import React from 'react';

import type { OccupationsListItem } from '~/types/refData';

const highlightWords = (text: string, search: string, color: string) => {
  const results = [] as ReactNode[];
  const searchLc = search.toLowerCase();
  const textLc = text.toLowerCase();
  let lastIndex = 0;

  while (lastIndex < text.length) {
    const index = textLc.indexOf(searchLc, lastIndex);
    if (index >= 0) {
      results.push(text.slice(lastIndex, index));
      results.push(
        <span key={index} style={{ color }}>
          {text.slice(index, index + search.length)}
        </span>
      );
      lastIndex = index + search.length;
    } else {
      results.push(<span key={index}>{text.slice(lastIndex)}</span>);
      break;
    }
  }

  return results;
};

export const truncate = (
  item: OccupationsListItem,
  options: {
    property: keyof OccupationsListItem;
    textLength?: number;
  }
) => {
  const text = item[options.property];
  if (!text) return '';

  const truncText =
    options.textLength !== undefined && text.length > options.textLength
      ? `${text.slice(0, options.textLength)}...`
      : text;

  return truncText;
};

export const wordHighlighter = (
  item: OccupationsListItem,
  options: {
    searchTerm: string;
    property: keyof OccupationsListItem;
    textLength?: number;
    color: string;
  }
) => {
  const text = item[options.property];
  if (!text) return '';

  const truncText =
    options.textLength !== undefined && text.length > options.textLength
      ? `${text.slice(0, options.textLength)}...`
      : text;

  return highlightWords(truncText ?? '', options.searchTerm, options.color);
};
